import { getDemoData, matchRestRequest } from '../utils'
import { Work } from 'typings/common_defs'

export const mockGetWorkers = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/workers_query_with_rosters_a4f1de11',
      'POST'
    ) ||
    matchRestRequest(
      request,
      '/company/graphql_dispatch/workers_query_ad2042ef',
      'POST'
    ),
  getResponse: async (request) => {
    const demoData = getDemoData()
    const workers = demoData.workers
    const rosters = demoData.rosters
    const params = request.data
    const query = params.search
      ? (params.search as string).trim().toLowerCase()
      : ''

    const allWork = demoData.shifts
      .map((shift) =>
        (shift.work ?? []).map((work) => ({
          ...work,
          shift,
        }))
      )
      .flat()
    const getWorkForCompany = (workerId: number) => {
      return allWork.filter((work) => work.worker?.id === workerId)
    }

    return {
      data: {
        company: {
          workers2: {
            cursor: null,
            items: (query
              ? workers.filter((worker) =>
                  worker.name.toLowerCase().includes(query)
                )
              : workers
            ).map((worker) => {
              const workForCompany = getWorkForCompany(worker.id)
              const lastShift = getLastShift(workForCompany)
              return {
                ...worker,
                rosters: rosters.filter((roster) =>
                  roster.workers.some(
                    (rosterWorker) => rosterWorker.id === worker.id
                  )
                ),
                numShiftsForCompany: workForCompany.length,
                workForCompany: lastShift
                  ? [
                      {
                        startedAt: lastShift?.startsAt,
                      },
                    ]
                  : [],
              }
            }),
          },
        },
      },
    }
  },
}

export function getLastShift(workForCompany: Work[]) {
  const sortedWork = workForCompany
    .filter((work) => ['completed', 'paid'].includes(work.status ?? ''))
    .sort((a, b) => {
      const aStart = new Date(a.shift!.startsAt!)
      const bStart = new Date(b.shift!.startsAt!)
      return bStart.getTime() - aStart.getTime()
    })
  return sortedWork[0]?.shift
}
